import SearchConstants from 'constants/search';
import I from 'immutable';
import _ from 'underscore';
import Flux from 'lib/flux';

const SEARCH_DATE_FORMAT = 'DD-MM-YYYY';

const SearchStore = Flux.createStore({
  name: 'search',

  getInitialState() {
    return {
      location: null,
      tours: [],
      filters: {
        categories: [],
        availability: {
          from: null,
          to: null,
          format: SEARCH_DATE_FORMAT,
          people: 1,
        },
      },
      sort: 'relevance',
      meta: {},
      searching: false,
      filtering: false,
      inquiring: false,
      appending: false,
      inquiryErrors: {},
      inquiryCompleted: false,
    };
  },

  actions: [
    [
      SearchConstants.UPDATE_AVAILABILITY_PEOPLE,
      function (value) {
        this.state = this.state.setIn(['meta', 'current_page'], 1);
        this.state = this.state.setIn(
          ['filters', 'availability', 'people'],
          value
        );
      },
    ],

    [
      SearchConstants.UPDATE_AVAILABILITY_DATES,
      function (fromDate, toDate, format) {
        this.state = this.state.updateIn(['filters', 'availability'], (x) =>
          x.merge({
            from: fromDate,
            to: toDate,
            format,
          })
        );
        this.state = this.state.setIn(['meta', 'current_page'], 1);
      },
    ],

    [
      SearchConstants.UPDATE_CATEGORIES,
      function (value) {
        this.state = this.state.setIn(
          ['filters', 'categories'],
          I.fromJS(value)
        );
        this.state = this.state.setIn(['meta', 'current_page'], 1);
      },
    ],

    [
      SearchConstants.SEARCH,
      function () {
        this.state = this.state.set('searching', true);
      },
    ],

    [
      SearchConstants.SEARCH_COMPLETED,
      function (payload) {
        if (this.state.get('appending') === true) {
          payload.tours = this.state.get('tours').toJS().concat(payload.tours);
        }

        this.state = I.fromJS(payload);
        this.state = this.state.set('searching', false);
        this.state = this.state.set('filtering', false);
        this.state = this.state.set('appending', false);
      },
    ],

    [
      SearchConstants.CHANGE_PAGE,
      function (page) {
        this.state = this.state.setIn(['meta', 'current_page'], page);
      },
    ],

    [
      SearchConstants.APPEND_PAGE,
      function (page) {
        this.state = this.state.set('appending', true);
        this.state = this.state.setIn(['meta', 'current_page'], page);
      },
    ],

    [
      SearchConstants.SORT_BY,
      function (sort) {
        this.state = this.state.set('sort', sort);
        this.state = this.state.setIn(['meta', 'current_page'], 1);
      },
    ],

    [
      SearchConstants.FILTER,
      function (_payload) {
        this.state = this.state.set('filtering', true);
      },
    ],

    [
      SearchConstants.FILTER_COMPLETED,
      function (_payload) {
        this.state = this.state.set('filtering', false);
      },
    ],

    [
      SearchConstants.INQUIRE,
      function (_payload) {
        this.state = this.state.set('inquiring', true);
        this.state = this.state.set('inquiryErrors', {});
        this.state = this.state.set('inquiryCompleted', false);
      },
    ],

    [
      SearchConstants.INQUIRE_COMPLETED,
      function (_payload) {
        this.state = this.state.set('inquiring', false);
        this.state = this.state.set('inquiryCompleted', true);
      },
    ],

    [
      SearchConstants.INQUIRE_FAILED,
      function (payload) {
        this.state = this.state.set('inquiring', false);
        this.state = this.state.set('inquiryErrors', payload.errors);
      },
    ],
  ],
});

export default SearchStore;
